import React, { PureComponent } from 'react';

export default class InputSwitch extends PureComponent {

	constructor(props) {
		super(props);
	}

	render() {
		const { children, onChange, onContent, offContent, checked, highlightsSelections, disabled } = this.props;
		return (
			<div className={`switch ${highlightsSelections ? 'highlights_selections' : ''}`}>
				<label className='switch_label'>
					<span className={`option ${checked ? 'unselected' : 'selected'}`}>
					{offContent}
					</span>
					<input
						disabled={disabled}
						onChange={onChange}
						checked={checked}
						type='checkbox'
						value=''
					/>
					<span
						className='lever'
					/>
					<span className={`option ${checked ? 'selected' : 'unselected'}`}>
					{onContent || children}
					</span>
				</label>
			</div>
		);
	}
}